/**
 * @see When adding a new right, we need to remember to add it to all existing user roles including
 * ~bite~ roles. Then all users with affected roles will need to be updated to get the new rights.
 */
enum UserRight {
  SendOrderToLivePos = 2,
  KioskRight = 10,
  FlashRight = 11,
  ApiToken = 12,
  RefundOrders = 20,
  ControlKiosk = 21,
  ViewOrders = 25,
  AllVendorAccess = 27,
  ViewMenuLibrary = 28,
  Reporting = 30,
  VerifyAlcoholPurchases = 34,
  Items86 = 38,
  ManageMenu = 40,
  ManageOpenHours = 41,
  ManageLowerUsers = 45,
  ManageMenuCovers = 46,
  ManageDiscounts = 47,
  EditMenuAppearance = 50,
  ManageChannelSettings = 51,
  ToggleDiningOptions = 52,
  ShowFlashClosedScreen = 56,
  ManageBiteLift = 57,
  ManageOrderThrottling = 60,
  ManageCustomers = 65,
  ManageWebSettings = 66,
  ManageCateringSettings = 67,
  ManageOtherUsersChangeset = 68,

  // Former Bite Only Rights
  ViewActivities = 71,
  ManageI9nLite = 72,
  ViewSystemLogsLite = 73,
  DeleteCustomers = 82,
  ManageBrandColorAndLogo = 83,
  ManageThirdPartyPrivacyPolicy = 84,

  Admin = 89,

  // Reseller Rights
  MagicCopyLocation = 90,
  CreateSitesAndChannels = 91,
  ManageI9n = 92,
  ViewSystemLogs = 93,
  ManageSupportedLanguages = 94,
  ManageKiosks = 95,
  ManageCommonSettings = 96,
  ManageMenuAdvanced = 97,

  // Bite Rights
  BiteAccess = 100,
  BiteSupport = 110,
  BiteOps = 120,
  ManageLowerBiteUsers = 130,
  BiteEng = 150,
  BiteAdmin = 200,

  // API Token Rights
  ApiTokenReporting = 300,
  ApiTokenMobileApp = 301,
  ApiTokenLocations = 302,
}

export { UserRight };
